import React from 'react';

const WhyUsCard = ({whyChooseUsCard}) => {
    return (
        <article className='why_us-card'>
            <img src={whyChooseUsCard.url} alt="" className="why_us-card-img" />
            <div className="why_us-card-content">
                <h3 className="why_us-card-title">{whyChooseUsCard.title}</h3>
                <p className="why_us-card-text">{whyChooseUsCard.text}</p>
            </div>
        </article>
    );
}

export default WhyUsCard;
